import { ErrorFields } from "./ErrorFields";

export const FindGridNullValue = (rowDataFinal) => {
  let emptyArray = [];
  rowDataFinal?.map((items) => {
    if (checkNullValue(items[checkFields(items)])) {
      const dataField = checkFields(items);
      dataField?.map((item) => {
        if (
          item === ErrorFields.newYear &&
          checkNullValue(items[ErrorFields.newYear],item)
        ) {
          emptyArray.push({
            [ErrorFields.newYear]: items[ErrorFields.newYear],
          });
        }
        if (
          item === ErrorFields.newModel &&
          checkNullValue(items[ErrorFields.newModel],item)
        ) {
          emptyArray.push({
            [ErrorFields.newModel]: items[ErrorFields.newModel],
          });
        }
        if (
          item === ErrorFields.newMake &&
          checkNullValue(items[ErrorFields.newMake],item)
        ) {
          emptyArray.push({
            [ErrorFields.newMake]: items[ErrorFields.newMake],
          });
        }
        if (
          item === ErrorFields.newMpg &&
          checkNullValue(items[ErrorFields.newMpg],item)
        ) {
          emptyArray.push({ [ErrorFields.newMpg]: items[ErrorFields.newMpg] });

          const index = emptyArray.findIndex((obj) =>
            obj.hasOwnProperty(ErrorFields.mpg)
          );
          if (index !== -1) emptyArray.splice(index, 1);
        }
        if (
          item === ErrorFields.mpg &&
          checkNullValue(items[ErrorFields.mpg],item) &&
          checkNullValue(items[ErrorFields.newMpg],item)
        ) {
          emptyArray.push({ [ErrorFields.mpg]: items[ErrorFields.mpg] });
        }
        if (
          item === ErrorFields.paymentAmount &&
          checkNullValue(items[ErrorFields.paymentAmount],item)
        ) {
          emptyArray.push({
            [ErrorFields.paymentAmount]: items[ErrorFields.paymentAmount],
          });
        }
        if (
          item === ErrorFields.fundingType &&
          checkNullValue(items[ErrorFields.fundingType],item)
        ) {
          emptyArray.push({
            [ErrorFields.fundingType]: items[ErrorFields.fundingType],
          });
        }
        if (
          item === ErrorFields.newVehicleCost &&
          checkNullValue(items[ErrorFields.newVehicleCost],item)
        ) {
          emptyArray.push({
            [ErrorFields.newVehicleCost]: items[ErrorFields.newVehicleCost],
          });
        }
        if (
          item === ErrorFields.newEstimatedResaleValue &&
          checkNullValue(items[ErrorFields.newEstimatedResaleValue],item)
        ) {
          emptyArray.push({
            [ErrorFields.newEstimatedResaleValue]:
              items[ErrorFields.newEstimatedResaleValue],
          });
        }
        if (
          item === ErrorFields.residualPercentage &&
          checkNullValue(items[ErrorFields.residualPercentage],item)
        ) {
          emptyArray.push({
            [ErrorFields.residualPercentage]:
              items[ErrorFields.residualPercentage],
          });
        }
        if (
          item === ErrorFields.make &&
          checkNullValue(items[ErrorFields.make],item)
        ) {
          emptyArray.push({ [ErrorFields.make]: items[ErrorFields.make] });
        }
        // if (
        //   item === ErrorFields.model &&
        //   checkNullValue(items[ErrorFields.model])
        // ) {
        //   emptyArray.push({ [ErrorFields.model]: items[ErrorFields.model] });
        // }
        if (
          item === ErrorFields.year &&
          checkNullValue(items[ErrorFields.year],item)
        ) {
          emptyArray.push({ [ErrorFields.year]: items[ErrorFields.year] });
        }
        if (
          item === ErrorFields.fuel &&
          checkNullValue(items[ErrorFields.fuel],item)
        ) {
          emptyArray.push({ [ErrorFields.fuel]: items[ErrorFields.fuel] });
        }
        //Hide because client require to hide for now
        // if (
        //   item === ErrorFields.driveTrain &&
        //   checkNullValue(items[ErrorFields.driveTrain])
        // ) {
        //   emptyArray.push({
        //     [ErrorFields.driveTrain]: items[ErrorFields.driveTrain],
        //   });
        // }
        if (
          item === ErrorFields.type &&
          checkNullValue(items[ErrorFields.type],item)
        ) {
          emptyArray.push({ [ErrorFields.type]: items[ErrorFields.type] });
        }
      });
    }
  });
  return emptyArray;
};

export const checkFields = (fields) => {
  if (Object.keys(fields)?.length > 0) {
    return Object.keys(fields);
  }
};

export const uniqueNullValues = (rowDataFinal) => {
  const nullValues = FindGridNullValue(rowDataFinal);
  const uniqueKeys = [...new Set(nullValues.flatMap(Object.keys))];
  if (uniqueKeys?.length > 0) {
    return uniqueKeys;
  } else {
    return "";
  }
};
export const uniqueVehicleNullValues = (rowDataFinal) => {
  const nullValues = FindGridNullValue(rowDataFinal);
  const uniqueKeys = [...new Set(nullValues.flatMap(Object.keys))];
  if (uniqueKeys?.length > 0) {
    return uniqueKeys;
  } else {
    return "";
  }
};
export const checkNullValue = (item,itemField) => {
  if(itemField === ErrorFields.residualPercentage){
    return item === null || item === undefined || item === "";
  }else{
    return item === null || item === undefined || item === "" || item === 0 || item === "0";
  }
};

export const getNullVehicleFields = (fields) => {
  if (fields?.length > 0) {
    const jsonObject = Object.assign(
      {},
      ...fields?.map((key) => ({ [key]: undefined }))
    );
    const keys = Object.keys(jsonObject);
    const keysString = keys.join(", ");
    return keysString;
  }
};
